import React, { memo } from 'react'

import { Icon } from '@procsea/design-system'

import { IconProps } from './icons.types'

const DropShippingSupplierIcon = ({
  'data-e2e': dataE2e = 'drop-shipping-supplier',
  tooltip,
}: IconProps) => (
  <Icon
    data-e2e={dataE2e}
    faStyle="far"
    name="truck-arrow-right"
    size="1x"
    tooltip={tooltip}
    variant="primary"
  />
)

export default memo(DropShippingSupplierIcon)
